<template>
  <div class="content">
    <h1 class="subject">{{ subject }}</h1>
    <div class="name-container">
      <Avatar :name="sender" />
      <span>{{ sender }}</span>
    </div>
    <div class="body" v-if="!html">{{ body }}</div>
    <iframe
      ref="iframe"
      class="iframe-body"
      frameborder="0"
      width="100%"
      :src="`/game-content/${gameStateKey}/email/${html}`"
      @load="onIframeLoad"
      v-if="html"
    ></iframe>
  </div>
</template>

<script>
import "core-js/features/string/replace-all";
import Avatar from "@/components/shared/Avatar";
import gameStateStore from "@/stores/GameStateStore";

export default {
  name: "EmailSidebar",
  components: { Avatar },
  props: {
    sender: String,
    subject: String,
    body: String,
    html: String,
    gameStateKey: String,
  },
  data() {
    return { htmlEmail: undefined };
  },
  methods: {
    onFirstDayAccept(e) {
      e.preventDefault();

      this.$emit("firstDayAccept");
    },
    onIframeLoad() {
      const iframe = this.$refs.iframe;

      iframe.style.height =
        iframe.contentWindow.document.body.scrollHeight + "px";
      iframe.contentWindow.document.body.innerHTML = iframe.contentWindow.document.body.innerHTML.replaceAll(
        "{{name}}",
        gameStateStore.username
      );
      iframe.contentWindow.document.body
        .querySelector("#accept-button")
        ?.addEventListener("click", this.onFirstDayAccept);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";
@import "@/assets/mixins";

.content {
  @include style-scrollbars(rgba(black, 0.4), white);

  position: relative;

  height: 100%;
  flex: 2;
  background-color: white;

  box-sizing: border-box;
  color: $primary-text-black;

  white-space: pre-line;
  overflow: auto;

  .subject {
    margin: 32px;
  }

  .name-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    margin-left: 32px;
    margin-right: 32px;

    span {
      margin-left: 8px;
      font-size: 1em;
      color: $secondary-text-black;
    }
  }

  .body {
    margin: 32px;
  }

  .iframe-body {
    display: block;

    border: none;
    margin: 0px;
    padding: 0px;

    margin-top: 32px;

    width: 100%;
    overflow: visible;
  }
}
</style>
